import { useEffect, useState } from 'react';
import Grid from '../../../shared/Grid';

import './Table.scss';

export default function Table(props) {
    const [gridHeaders, setGridHeaders] = useState();
    const [gridData, setGridData] = useState();

    useEffect(() => {
        let _headerKeys = [];

        //dhSwitch : boolean : true for header parse, false for data parse
        const parseGridDataHeaders = (dhSwitch, data) => {
            let _returnData = dhSwitch
                ? data.options[0].text['en-US'].split('|').map((entry) => {
                      let _colName = entry.split(' ');
                      _colName[0] = _colName[0].toLowerCase();
                      _colName = _colName.join('');

                      _headerKeys.push(_colName);

                      return {
                          colLabel: entry,
                          colName: _colName,
                      };
                  })
                : {
                      rows: data.options.slice(1).map((entry) => {
                          return {
                              columns: entry.text['en-US'].split('|').map((col, i) => {
                                  return (
                                      <span
                                          key={`key-${col}`}
                                          colname={_headerKeys[i]}
                                      >
                                          {col}
                                      </span>
                                  );
                              }),
                          };
                      }),
                  };
            // null;

            return _returnData;
        };

        setGridHeaders(!!props?.question ? parseGridDataHeaders(true, props.question) : null);
        setGridData(!!props?.question ? parseGridDataHeaders(false, props.question) : null);
    }, [props.question]);

    return !!gridHeaders && !!gridData ? (
        <Grid
            headers={gridHeaders}
            data={gridData}
            filters={false}
            counter={false}
            className="table-question"
            selectable={false}
        />
    ) : null;
}
